import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import client from "../api/client";
import "./RecentLogs.css";

const recordName = (value) => {
  const data = typeof value === "string" ? JSON.parse(value) : value || {};
  return data.name || data.product_name || data.customer_name || data.supplier_name || data.order_id || data.id || "Deleted record";
};

export default function RecentLogs() {
  const navigate = useNavigate();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [restoringId, setRestoringId] = useState(null);
  const [message, setMessage] = useState("");

  const loadLogs = async () => {
    setLoading(true);
    try {
      const { data } = await client.get("/recent-logs");
      setLogs(Array.isArray(data) ? data : []);
    } catch (error) {
      setMessage(error.response?.data?.message || "Recent logs could not be loaded.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { loadLogs(); }, []);

  const restore = async (id) => {
    setRestoringId(id);
    setMessage("");
    try {
      const { data } = await client.post(`/recent-logs/${id}/restore`);
      setLogs((items) => items.filter((item) => item.id !== id));
      setMessage(data.message || "Record restored successfully.");
    } catch (error) {
      setMessage(error.response?.data?.message || "Record could not be restored.");
    } finally {
      setRestoringId(null);
    }
  };

  return (
    <main className="recent-logs-page">
      <div className="recent-logs-header">
        <div>
          <span>System activity</span>
          <h1>Recent Logs</h1>
          <p>Deleted records from across the system are available here for restoration.</p>
        </div>
        <button type="button" className="recent-logs-back" onClick={() => navigate("/dashboard")}>Back to Dashboard</button>
      </div>
      {message && <div className="recent-logs-message">{message}</div>}
      <section className="recent-logs-card">
        <div className="recent-logs-title"><h2>Deleted Records</h2><button type="button" onClick={loadLogs}>Refresh</button></div>
        {loading ? <div className="recent-logs-empty">Loading logs...</div> : logs.length === 0 ? <div className="recent-logs-empty">No deleted records available.</div> : (
          <div className="recent-logs-table-wrap"><table><thead><tr><th>Module</th><th>Record</th><th>Record ID</th><th>Deleted On</th><th>Action</th></tr></thead><tbody>
            {logs.map((log) => <tr key={log.id}><td>{log.module_name}</td><td>{recordName(log.record_data)}</td><td>#{log.source_id}</td><td>{new Date(log.deleted_at).toLocaleString()}</td><td><button type="button" className="recent-logs-restore" disabled={restoringId === log.id} onClick={() => restore(log.id)}>{restoringId === log.id ? "Restoring..." : "Restore"}</button></td></tr>)}
          </tbody></table></div>
        )}
      </section>
    </main>
  );
}
